module.exports = __webpack_public_path__ + "img/slider4.bbb0b18b.gif";